<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { add, edit } from "@/api/file/category";
export default {
    data() {
        return {
            visible: false,
            title: "新增分类",
            form: {
                name: "",
            },
            rules: {
                name: [{ required: true, message: "请输入分类名称" }],
            },
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.title = "编辑分类";
                this.form.name = row.name;
                this.form.uuid = row.uuid;
            } else {
                this.title = "新增分类";
                this.form.name = "";
                this.form.uuid = "";
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                if (this.form.uuid) {
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.$emit("update");
                            this.visible = false;
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
                            this.$emit("update");
                            this.visible = false;
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
